import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

import { EnableClassTelemetry } from 'app/services/otel.service';
import { WidgetDataSource } from '../../../models';

export interface SpecialImpactWidgetHideData {
  id: string;
  label: string;
}

export interface SpecialImpactWidgetUnhideData {
  id: string;
  idx: number;
}

export interface SpecialImpactWidgetAnalyticTypeData {
  id: string;
  analyticType: any;
}

@EnableClassTelemetry()
@Injectable()
export class PredictiveWidgetDataService {
  private twtraDataSourceChangeEmitter$ = new Subject<WidgetDataSource>();
  private specialImpactHideChangeEmitter$ = new Subject<SpecialImpactWidgetHideData>();
  private specialImpactUnhideChangeEmitter$ = new Subject<SpecialImpactWidgetUnhideData>();
  private specialImpactAnalyticTypeChangeEmitter$ =
    new Subject<SpecialImpactWidgetAnalyticTypeData>();

  public onTwtraDataSourceChanged = this.twtraDataSourceChangeEmitter$.asObservable();
  public onSpecialImpactHideChanged = this.specialImpactHideChangeEmitter$.asObservable();
  public onSpecialImpactUnhideChanged = this.specialImpactUnhideChangeEmitter$.asObservable();
  public onSpecialImpactAnalyticTypeChanged =
    this.specialImpactAnalyticTypeChangeEmitter$.asObservable();

  changeTwtraDataSource(dataSource: WidgetDataSource): void {
    this.twtraDataSourceChangeEmitter$.next(dataSource);
  }

  changeSpecialImpactHide(data: SpecialImpactWidgetHideData): void {
    this.specialImpactHideChangeEmitter$.next(data);
  }

  changeSpecialImpactUnhide(data: SpecialImpactWidgetUnhideData): void {
    this.specialImpactUnhideChangeEmitter$.next(data);
  }

  changeSpecialImpactAnalyticType(data: SpecialImpactWidgetAnalyticTypeData): void {
    this.specialImpactAnalyticTypeChangeEmitter$.next(data);
  }
}
